import React, { useMemo } from 'react';
import { Tabs } from 'antd';
import './TabsPrestasi.css';

const TabsPrestasi = (props) => {
  const { title } = props;
  const slot = useMemo(() => {
    return ['left'].reduce(
      (acc, direction) => ({
        ...acc,
        [direction]: (
          title && (
              <h2 className='title-tab-prestasi'>{title}</h2>
          )
        ),
      }),
      {},
    );
  }, [title]);

  return <Tabs tabBarExtraContent={slot} defaultActiveKey={props.defaultActiveKey || "siswa"} activeKey={props.activeKey} onChange={props.onChange} items={props.items} />
};
export default TabsPrestasi;